import axios from "axios";
import label from "@/lang/StaticLabels.js";
import alert from "@/lang/AlertMessages.js";
const baseUrl = "base/api/v1/";
const saleUrl = "sale/api/v1/";
// تنظیمات زیرسیستم فروشگاهی و زیرسیستم غرفه؛ هر دو همان صفحه عمومی تنظیمات
const settingUrls = {
  shop: saleUrl + "basic/shop/Setting",
  booth: saleUrl + "basic/shop/BoothSetting",
};
// پیش فاکتور غرفه
const preOrderUrl = saleUrl + "operation/shop/PreOrder";
// فروشگاه و غرفه (سرویس بیس)
const storeUrl = baseUrl + "Store";
const boothUrl = baseUrl + "Booth";
// فاکتور فروش فروشگاه؛ محاسبه، قیمت و تسویه همان سرویس‌های فاکتور فروش‌اند
const shopSaleFactorUrl = saleUrl + "operation/shop/SaleFactor";
const saleFactorUrl = saleUrl + "operation/SaleFactor";
const splyUrl = "sply/api/v1/";

// درخواست‌های فرم فاکتور فروشگاه: نتیجه را برمی‌گردانند و خطا را نمایش می‌دهند
function request({ dispatch, commit }, promise, options = {}) {
  const { button = false, silent = false, success = false } = options;
  if (button) commit("setLoadingBtn", true, { root: true });
  return promise
    .then((res) => {
      if (success) {
        commit("setSuccess", res.data.message || alert.success.submit, {
          root: true,
        });
      }
      // عملیات ثبت / حذف موفق هرگز null برنمی‌گرداند (null یعنی خطا)
      if (button) return res.data.data ?? true;
      return res.data.data;
    })
    .catch((error) => {
      const handler = silent
        ? "errorGETHandlerSilent"
        : button
          ? "errorPOSTHandler"
          : "errorGETHandler";
      dispatch(handler, error, { root: true });
      return null;
    })
    .finally(() => {
      if (button) commit("setLoadingBtn", false, { root: true });
    });
}

export default {
  // Setting Actions ------------------------------------------------------------------
  // type: "shop" | "booth"
  getSetting({ dispatch, commit }, type) {
    commit("setSetting", []);
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(settingUrls[type])
      .then((res) => {
        commit("setSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // data: { type, id, value }
  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(settingUrls[data.type] + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // DropDown Actions (سرویس بیس) ---------------------------------------------
  // غرفه‌های فعال؛ storeId اختیاری
  getBooths({ dispatch, commit }, storeId = null) {
    return axios
      .get(baseUrl + "DropDown/Booths" + (storeId ? "?storeId=" + storeId : ""))
      .then((res) => {
        commit("setBooths", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // فروشگاه‌های فعال شعبه
  getStoreOptions({ dispatch, commit }) {
    return axios
      .get(baseUrl + "DropDown/Stores")
      .then((res) => {
        commit("setStoreOptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // کاربران عضو شعبه جاری به همراه شخص هر کاربر در شعبه
  getBranchUserPersons({ dispatch, commit }) {
    return axios
      .get(baseUrl + "DropDown/BranchUserPersons")
      .then((res) => {
        commit("setBranchUserPersons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // پیش‌فرض‌های فروشگاه برای پر کردن پیش‌فرض‌های غرفه؛ دسترسی Store می‌خواهد
  getStoreDefaults({ dispatch }, id) {
    return axios
      .get(storeUrl + "/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },
  // پیش‌فرض‌های غرفه (سرپرست فروش، نوع فروش، سیاست قیمت‌گذاری، نوع تسویه) فقط در
  // جزئیات غرفه هست که دسترسی Booth می‌خواهد؛ کاربر غرفه ممکن است آن را نداشته
  // باشد، پس خطا بی‌صدا رد می‌شود و فرم بدون پیش‌فرض می‌ماند.
  getBoothDefaults({ dispatch }, id) {
    return axios
      .get(baseUrl + "Booth/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  // Store Actions - فروشگاه (سرویس بیس) -----------------------------------------
  // data: رشتهٔ کوئری فیلترها
  getStores({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(storeUrl + "?" + data)
      .then((res) => {
        commit("setStores", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getStoreById({ dispatch }, id) {
    return axios
      .get(storeUrl + "/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getStoreMaxCode({ dispatch }) {
    return axios
      .get(storeUrl + "/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  addStore({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(storeUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editStore({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(storeUrl + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteStore({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(storeUrl, { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Booth Actions - غرفه (سرویس بیس) -----------------------------------------
  // data: رشتهٔ کوئری فیلترها
  getBoothList({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(boothUrl + "?" + data)
      .then((res) => {
        commit("setBoothList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBoothById({ dispatch }, id) {
    return axios
      .get(boothUrl + "/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getBoothMaxCode({ dispatch }) {
    return axios
      .get(boothUrl + "/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  addBooth({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(boothUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREBoothList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBooth({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(boothUrl + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREBoothList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBooth({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(boothUrl, { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PreOrder Actions - پیش فاکتور غرفه ---------------------------------------------
  // data: رشتهٔ کوئری فیلترها (fromDate، toDate، boothId، personClubId، isCancel)
  getPreOrders({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(preOrderUrl + "?" + data)
      .then((res) => {
        commit("setPreOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPreOrderById({ dispatch, commit }, id) {
    commit("setPreOrderById", null);
    return axios
      .get(preOrderUrl + "/" + id)
      .then((res) => {
        commit("setPreOrderById", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // شماره بعدی فقط نمایشی است؛ شماره واقعی سمت سرور داده می‌شود
  getPreOrderMaxCode({ dispatch }) {
    return axios
      .get(preOrderUrl + "/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  // محاسبه یک سطر کالا (بدنه همان CalculateOrderQuery سفارش)
  calculatePreOrderCommodity({ dispatch }, data) {
    return axios
      .post(preOrderUrl + "/Calculate", data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  addPreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(preOrderUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREPreOrderList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(preOrderUrl + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREPreOrderList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(preOrderUrl, { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // انصراف (isCancel = true) یا برگشت انصراف (isCancel = false)
  // data: { id, isCancel, cancelReason }
  cancelPreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(preOrderUrl + "/" + data.id + "/Cancel", {
        isCancel: data.isCancel,
        cancelReason: data.cancelReason,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Shop SaleFactor Actions - فاکتور فروش فروشگاه ------------------------------
  // data: رشتهٔ کوئری فیلترها (fromDate، toDate، fromCode، toCode، storeId)
  getShopSaleFactors({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(shopSaleFactorUrl + "?" + data)
      .then((res) => {
        commit("setShopSaleFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // فاکتوری که کاربر به فروشگاهش دسترسی ندارد null برمی‌گردد
  getShopSaleFactorById(context, id) {
    return request(context, axios.get(shopSaleFactorUrl + "/" + id));
  },
  getShopSaleFactorByCode(context, code) {
    return request(
      context,
      axios.get(shopSaleFactorUrl + "/Get/" + encodeURIComponent(code)),
    );
  },
  // data: رشتهٔ کوئری (code، navigation، storeId)
  navigateShopSaleFactor(context, data) {
    return request(
      context,
      axios.get(shopSaleFactorUrl + "/Navigation?" + data),
      { silent: true },
    );
  },
  // خروجی شناسه فاکتور؛ حواله و سند همان لحظه صادر می‌شوند
  addShopSaleFactor(context, data) {
    return request(context, axios.post(shopSaleFactorUrl, data), {
      button: true,
    });
  },
  // data: { id, value, calculateGift }
  editShopSaleFactor(context, data) {
    const query = data.calculateGift ? "?calculateGift=true" : "";
    return request(
      context,
      axios.put(shopSaleFactorUrl + "/" + data.id + query, data.value),
      { button: true },
    );
  },
  // data: لیست شناسه‌ها
  deleteShopSaleFactors(context, data) {
    return request(context, axios.delete(shopSaleFactorUrl, { data }), {
      button: true,
      success: true,
    });
  },
  // خروجی شناسه فاکتور مرجوعی
  returnShopSaleFactor(context, id) {
    return request(
      context,
      axios.post(shopSaleFactorUrl + "/" + id + "/Return"),
      { button: true, success: true },
    );
  },
  // خروجی شناسه فاکتور تازه
  copyShopSaleFactor(context, id) {
    return request(context, axios.post(shopSaleFactorUrl + "/" + id + "/Copy"), {
      button: true,
      success: true,
    });
  },
  // data: { reportId, ids }؛ خروجی لینک چاپ
  printShopSaleFactor(context, data) {
    return request(
      context,
      axios.post(shopSaleFactorUrl + "/Print/" + data.reportId, {
        ids: data.ids,
        filterMessage: data.filterMessage || "",
      }),
      { button: true },
    );
  },
  // چاپ از منوی print2؛ data: { id: reportId، value: { ids } }
  async getPrintStoreSaleFactor(context, data) {
    const link = await context.dispatch("printShopSaleFactor", {
      reportId: data.id,
      ids: data.value.ids,
      filterMessage: data.value.filterMessage,
    });
    if (link) {
      context.commit("setPrintLink", { printKey: "StoreSaleFactor", link });
    }
  },
  // شماره بعدی فقط نمایشی است؛ شماره واقعی سمت سرور داده می‌شود
  getSaleFactorMaxCode(context) {
    return request(context, axios.get(saleFactorUrl + "/MaxCode"), {
      silent: true,
    });
  },
  // محاسبه یک سطر کالا (همان Calculate فاکتور فروش)
  calculateSaleFactorCommodity(context, data) {
    return request(context, axios.post(saleFactorUrl + "/Calculate", data), {
      silent: true,
    });
  },
  // قیمت کالا در سیاست قیمت‌گذاری؛ خروجی { id, price } یا null
  getSaleCommodityPrice(context, { commodityId, salePricePolicyId }) {
    let query = "commodityId=" + commodityId;
    if (salePricePolicyId) query += "&salePricePolicyId=" + salePricePolicyId;
    return request(
      context,
      axios.get(
        saleUrl + "basic/SalePricePolicyCommodity/GetCommodityPrice?" + query,
      ),
      { silent: true },
    );
  },

  // همه قیمت‌های یک سیاست فروش؛ برای نمایش قیمت روی کاشی کالاها
  getSalePolicyPrices(context, salePricePolicyId) {
    return request(
      context,
      axios.get(
        saleUrl +
          "basic/SalePricePolicyCommodity?salePricePolicyId=" +
          salePricePolicyId,
      ),
      { silent: true },
    );
  },

  // پنل فروش ---------------------------------------------------------------
  // فروشگاه‌های کاربر جاری
  getUserStores({ dispatch, commit }) {
    return axios
      .get(baseUrl + "DropDown/UserStores")
      .then((res) => {
        commit("setUserStores", res.data.data);
        return res.data.data || [];
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },
  getSalePanelGroups({ dispatch, commit }) {
    return axios
      .get(splyUrl + "basic/CommodityGroup?showInSalePanel=true")
      .then((res) => {
        commit("setSalePanelGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
      });
  },
  getGroupCommodities(context, commodityGroupId) {
    return request(
      context,
      axios.get(
        splyUrl +
          "DropDown/Commodity?isActive=true&IsShowStock=true&commodityGroupId=" +
          commodityGroupId,
      ),
      { silent: true },
    );
  },
  // درج فوری فرد باشگاه؛ خروجی شناسه
  addQuickPersonClub(context, data) {
    return request(context, axios.post(saleUrl + "operation/PersonClub", data), {
      button: true,
      success: true,
    });
  },

  // SaleFactor Settlement Actions - تسویه فاکتور فروش ---------------------------
  // همه ۹ نوع؛ فرم بر اساس فروش / فروشگاه فیلتر می‌کند
  getOrderSettlementTypes({ dispatch, commit }) {
    return axios
      .get(saleUrl + "DropDown/OrderSettlementTypes")
      .then((res) => {
        commit("setOrderSettlementTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
      });
  },
  // silent: برای تشخیص وضعیت تسویه هنگام باز کردن فاکتور، بدون پیام خطا
  getSaleFactorSettlement(context, data) {
    const { id, silent } = typeof data === "object" ? data : { id: data };
    return request(
      context,
      axios.get(saleFactorUrl + "/" + id + "/Settlement"),
      { silent: !!silent },
    );
  },
  // خروجی پیام هشدار یا null؛ در خطا false
  // در فاکتور فروشگاه سرور همین‌جا کارت سطرهای کارتخوان را می‌کشد (هر سطر تا حدود ۲ دقیقه)،
  // پس درخواست نباید timeout داشته باشد
  addSaleFactorSettlement({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(saleFactorUrl + "/Settlement", data, { timeout: 0 })
      .then((res) => {
        const warning = res.data.data || null;
        if (warning) commit("setWarning", warning, { root: true });
        else {
          commit("setSuccess", res.data.message || alert.success.submit, {
            root: true,
          });
        }
        return { warning };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  deleteSaleFactorSettlement(context, saleFactorId) {
    return request(
      context,
      axios.delete(saleFactorUrl + "/" + saleFactorId + "/Settlement"),
      { button: true, success: true },
    );
  },
  getSettlementInstallments(context, data) {
    return request(
      context,
      axios.post(saleFactorUrl + "/Settlement/Installments", data),
      { silent: true },
    );
  },
  // کدهای تخفیف باشگاه؛ فقط وقتی فاکتور personClubId دارد پر است
  getSettlementDiscounts(context, saleFactorId) {
    return request(
      context,
      axios.get(saleFactorUrl + "/" + saleFactorId + "/Settlement/Discounts"),
      { silent: true },
    );
  },
  getSettlementCreditorBalance(context, { accountInfoId, personId }) {
    let query = "accountInfoId=" + accountInfoId;
    if (personId) query += "&personId=" + personId;
    return request(
      context,
      axios.get(saleFactorUrl + "/Settlement/CreditorBalance?" + query),
      { silent: true },
    );
  },
  // دستگاه‌های پوز و بن کارت‌های فعال برای سطرهای تسویه
  getActivePosTerminals({ dispatch, commit }) {
    return axios
      .get(baseUrl + "PosTerminal?isActive=true")
      .then((res) => {
        commit("setActivePosTerminals", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
      });
  },
  getActiveBenefitCards({ dispatch, commit }) {
    return axios
      .get(baseUrl + "BenefitCard?isActive=true&isBlock=false")
      .then((res) => {
        commit("setActiveBenefitCards", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
      });
  },
};
